import { validateExpression, createExpression, updateExpression, getExpressionById } from "api/expression";

const expressionsConfig = {
  edit: updateExpression,
  new: createExpression,
  validate: validateExpression,
  getById: getExpressionById
};

export default expressionsConfig;